import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Footer from '../../components/Footer/Footer';

// ---- Palette white / beige / gold ----
const colors = {
  bg: '#FFFFFF',
  gold: '#C69C6D',
  goldDark: '#B88A56',
  goldLight: '#F5E1C8',
  text: '#3B2F2A',
  textSoft: '#5C4A3D',
  cardBg: 'rgba(255, 255, 255, 0.7)',
  cardBorder: 'rgba(198, 156, 109, 0.25)',
  shadow: '0 8px 24px rgba(107, 90, 70, 0.06)',
  shadowHover: '0 16px 32px rgba(184, 138, 86, 0.15)',
};

// ---- Données inchangées ----
const references = [
  { 
    image: 'images/assets/1.png',
    title: 'Afrique/Société', 
    description: 'Ndagbia Mobutu partage son parcours afin d’inspirer des femmes à réaliser leurs rêves', 
    location: null,
    link: 'https://www.aci.cg/afrique-societe-ndagbia-mobutu-partage-son-parcours-afin-dinspirer-des-femmes-a-realiser-leurs-reves/',
    details: "Brazzaville, 20 Sept (ACI)- La Présidente directrice générale et fondatrice de la conciergerie de Luxe « Azyekos Services », Mme Ndagbia Mobutu Onkili Yaucat, a partagé, le 17 septembre à Brazzaville, son parcours afin d’inspirer des femmes à réaliser leurs rêves et ambitions à travers l’entrepreneuriat."
  },
  { 
    image: 'images/assets/2.png',
    title: 'Soirée de gala', 
    description: 'Femmes entrepreneures primées par le Forum', 
    location: null,
    details: "À l’occasion de la première édition du Forum Economique des Femmes Entrepreneures, plusieurs femmes entrepreneures qui se sont distinguées dans leur travail, leur capacité managériale et leur génie d’entreprendre, dans n’importe quel domaine, ont reçu des récompenses : Les ’’Awards Woman Business Champion’’."
  },
  { 
    image: 'images/assets/3.jpg',
    title: 'Diaspo Boost', 
    description: '1ère édition du « Comment créer sa société » en RDC', 
    location: null,
    details: "Ce week-end, Azyekos a participé à la 1ère édition de « Comment créer sa société en République démocratique du Congo » by Stephanie Kimbulu. Nous tenons à remercier chaleureusement Stephanie et son équipe pour cette belle initiative. Ce fut une journée de networking très intéressante et encourageante pour notre diaspora."
  },
  { 
    image: 'images/assets/4.jpg',
    title: 'Rumba in the Jungle', 
    description: 'Seli Safari Zongo, 03–05 décembre 2021', 
    location: null,
    details: "LE SAVIEZ-VOUS L’UNESCO s’apprête à inscrire la Rumba ou “N’KUMBA” au patrimoine immatériel de l’humanité Pour l’occasion #azyekos-services ainsi que d’autres partenaires sponsorisent l’événement RUMBA IN THE JUNGLE qui aura lieu du 03 au 05 décembre 2021.. au Seli Safari Zongo"
  },
  { 
    image: 'images/assets/5.jpeg',
    title: 'Dinner de Gala Fund Raising', 
    description: 'Fleuve Congo Hotel', 
    location: null,
    details: "Cette année Azyekos Services accompagne l’ONG @asbllamainsurlecoeur lors de son dîner de gala annuel de récolte de fonds en faveur des enfants vivant avec le virus du #VIHSida"
  },
  { 
    image: 'images/assets/10.jpg',
    title: 'Boutique Hôtel Palmeraie Marrakech', 
    description: 'Movenpick Mansour Eddahbi, Maroc', 
    location: 'Maroc',
    details: "Concept et design d'un hôtel boutique exclusif au cœur de la palmeraie de Marrakech. Service d'hôtellerie haut de gamme et décoration inspirée de l'artisanat local."
  },
  { 
    image: 'images/assets/9.jpg',
    title: 'Seli Safari Resort', 
    description: 'Resort Zongo, RDC', 
    location: 'RDC',
    details: "Développement complet d'un resort de luxe en pleine nature. Organisation de l'expérience client de A à Z, des activités safari au service gastronomique."
  },
  { 
    image: 'images/assets/9.jpeg',
    title: 'Cocktail de lancement', 
    description: 'Azyekos Services / Kinshasa', 
    location: 'Kinshasa',
    details: "Événement de lancement officiel d'Azyekos Services à Kinshasa. Organisation d'un cocktail d'exception avec plus de 300 invités prestigieux."
  },
  { 
    image: 'images/assets/6.png',
    title: 'Story Hotel Rabat', 
    description: 'Rabat, Maroc', 
    location: 'Maroc',
    details: "Conception et réalisation de l'expérience client pour un hôtel design à Rabat. Service sur mesure et organisation d'événements exclusifs."
  },
  { 
    image: 'images/assets/11.png',
    title: 'Teke Beach', 
    description: 'Domaine privé de Luxe, Sénégal', 
    location: 'Sénégal',
    details: "Organisation d'événements privés dans un domaine exclusif en bord de mer. Service premium incluant décoration, restauration et animation."
  },
  { 
    image: 'images/assets/8.png',
    title: 'Article dans "Le Nouvel Afrique"', 
    description: 'Organisation de grands événements', 
    location: null,
    details: "Reconnaissance médiatique pour notre expertise dans l'organisation d'événements d'envergure internationale et notre approche innovante."
  },
  { 
    image: 'images/assets/12.jpg',
    title: 'Zénith WOMAN UP', 
    description: '4e Édition du Zénith WOMAN UP', 
    location: null,
    details: "Ndagbia Mobutu rêve d’un Congo où dénoncer ne sera plus un risque au danger, mais un droit légal.Lors de la quatrième édition de La Tribune incontournable pour la réflexion sur les droits fondamentaux des femmes et des jeunes filles au nom du Zénith women Up qui a eu lieu le vendredi 06 juin 2025 à l'Institut National des Arts (INA)dans la ville province de Kinshasa, Directrice Générale d'AZYEKOS et Présidente de ce service a, dénoncée la violence faite à la femme, les tueries en cascades de vies humaines et la maltraitance envers les femmes ainsi que chez les jeunes filles."
  }
];

// ---- Modal (glassmorphism) ----
const ReferenceModal = ({ reference, onClose }) => {
  if (!reference) return null;

  return (
    <motion.div
      className="modal-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <motion.div
        className="modal-container"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <button className="modal-close" onClick={onClose}>&times;</button>
        {reference.image && (
          <div className="modal-image" style={{ backgroundImage: `url(${reference.image})` }}>
            <div className="modal-image-text">
              <h2>{reference.title}</h2>
              {reference.location && <span className="modal-location">{reference.location}</span>}
            </div>
          </div>
        )}
        <div className="modal-body">
          <p>{reference.details}</p>
          {reference.link && (
            <a href={reference.link} target="_blank" rel="noopener noreferrer" className="modal-link">
              Lire l'article
            </a>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default function References() {
  const [selectedReference, setSelectedReference] = useState(null);
  const openModal = useCallback((ref) => setSelectedReference(ref), []);
  const closeModal = () => setSelectedReference(null);

  return (
    <>
      <style>{`
        .references-page {
          background: ${colors.bg};
          min-height: 100vh;
          position: relative;
          overflow: hidden;
        }

        /* Halos dorés */
        .references-page::before,
        .references-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.2;
          z-index: 0;
          pointer-events: none;
        }
        .references-page::before {
          width: 50vw;
          height: 50vw;
          background: ${colors.goldLight};
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }
        .references-page::after {
          width: 40vw;
          height: 40vw;
          background: #EAD5C0;
          bottom: -8%;
          right: -4%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }
        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .content-wrapper {
          position: relative;
          z-index: 1;
          padding: 80px 20px 60px;
          max-width: 1400px;
          margin: 0 auto;
        }

        .page-title {
          font-size: clamp(2.2rem, 5vw, 3rem);
          font-weight: 700;
          color: ${colors.text};
          text-align: center;
          margin-bottom: 0.5rem;
          letter-spacing: -0.5px;
        }

        .title-underline {
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, ${colors.gold}, ${colors.goldDark});
          margin: 0 auto 50px;
          border-radius: 2px;
        }

        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 24px;
        }

        .ref-card {
          background: ${colors.cardBg};
          backdrop-filter: blur(18px);
          -webkit-backdrop-filter: blur(18px);
          border: 1px solid ${colors.cardBorder};
          border-radius: 24px;
          box-shadow: ${colors.shadow};
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
        }

        .ref-card:hover {
          transform: translateY(-6px);
          box-shadow: ${colors.shadowHover};
          border-color: ${colors.gold};
        }

        .ref-card-img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: block;
        }

        .ref-card-body {
          padding: 20px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .ref-card-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: ${colors.text};
          margin-bottom: 8px;
        }

        .ref-card-desc {
          font-size: 0.95rem;
          color: ${colors.textSoft};
          line-height: 1.5;
          margin-bottom: 0;
        }

        /* Modal styles */
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.6);
          backdrop-filter: blur(6px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
        }

        .modal-container {
          background: ${colors.cardBg};
          backdrop-filter: blur(24px);
          -webkit-backdrop-filter: blur(24px);
          border: 1px solid ${colors.cardBorder};
          border-radius: 32px;
          max-width: 700px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          position: relative;
        }

        .modal-close {
          position: absolute;
          top: 15px;
          right: 15px;
          background: rgba(198,156,109,0.15);
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          font-size: 1.5rem;
          color: ${colors.gold};
          cursor: pointer;
          z-index: 2;
          transition: background 0.2s;
        }
        .modal-close:hover {
          background: rgba(198,156,109,0.3);
        }

        .modal-image {
          height: 250px;
          background-size: cover;
          background-position: center;
          position: relative;
        }

        .modal-image-text {
          position: absolute;
          bottom: 20px;
          left: 20px;
          color: #fff;
          text-shadow: 0 2px 8px rgba(0,0,0,0.5);
        }

        .modal-image-text h2 {
          font-size: 1.6rem;
          margin-bottom: 5px;
        }

        .modal-location {
          background: ${colors.gold};
          color: #fff;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.8rem;
          display: inline-block;
        }

        .modal-body {
          padding: 25px;
        }

        .modal-body p {
          color: ${colors.textSoft};
          font-size: 1rem;
          line-height: 1.7;
          margin-bottom: 15px;
        }

        .modal-link {
          color: ${colors.gold};
          font-weight: 600;
          text-decoration: underline;
          transition: color 0.2s;
        }
        .modal-link:hover {
          color: ${colors.goldDark};
        }

        @media (max-width: 768px) {
          .content-wrapper {
            padding: 60px 16px 40px;
          }
          .cards-grid {
            grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
            gap: 16px;
          }
        }
      `}</style>


      <Header />

      <div className="references-page ">
        <div className="content-wrapper mt-5">
          <h1 className="page-title">Nos Références</h1>
          <div className="title-underline" />

          <motion.div
            className="cards-grid"
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
            }}
          >
            {references.map((ref, index) => (
              <motion.div
                key={index}
                className="ref-card"
                onClick={() => openModal(ref)}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 }
                }}
                transition={{ duration: 0.4 }}
              >
                {ref.image && <img src={ref.image} alt={ref.title} className="ref-card-img" />}
                <div className="ref-card-body">
                  <h3 className="ref-card-title">{ref.title}</h3>
                  <p className="ref-card-desc">{ref.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      <Footer />

      <AnimatePresence>
        {selectedReference && (
          <ReferenceModal reference={selectedReference} onClose={closeModal} />
        )}
      </AnimatePresence>
    </>
  );
}